import React, { useEffect, useState } from "react";
import { useAuth } from "react-uicomp";
import { api, APIS, FILE_URL } from "../../../config/Config";
import Title from "../../common/title/Title.common";
import CompWrapper from "../../hoc/compWrapper/CompWrapper.hoc";
export const CitizenCharter = () => {
  const { setHeaderTitle } = useAuth();
  const [citizenCharter, setCitizenCharter] = useState();

  useEffect(() => {
    setHeaderTitle("Citizen Charter");
  }, [setHeaderTitle]);

  useEffect(() => {
    (async () => {
      const res = await api(`${APIS.citizen_charter}`);
      const { success, data } = res.data;
      if (success === "true") {
        setCitizenCharter(data?.data?.rows[0]);
      }
    })();
  }, []);

  return (
    <CompWrapper>
      <Title title="Citizen Charter" hide_SeeAll />
      {citizenCharter?.images?.map((item, i) => {
        return (
          <img
            className="image-showcase"
            width="100%"
            src={FILE_URL + item}
            key={i}
          />
        );
      })}
    </CompWrapper>
  );
};
